import React from 'react';
import { motion } from 'framer-motion';
export function HighlightSection() {
  return <section className="py-12 md:py-16 bg-gradient-to-br from-stone-50 to-amber-50" data-id="element-136">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white p-8 md:p-12 rounded-2xl md:rounded-3xl shadow-2xl border-l-8 border-amber-500" data-id="element-138">
          <p className="text-xl md:text-2xl lg:text-3xl text-stone-800 leading-relaxed text-center font-light" data-id="element-139">
            A maioria das noivas não gasta mais porque quer.
            <br data-id="element-140" />
            <span className="font-bold text-stone-900" data-id="element-141">
              Gasta porque tem medo de economizar e parecer simples.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}